import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { MainMenuModule } from '../main-menu/main-menu.module';
import { ButtonModule } from './../button/button.module';
import { NavbarComponent } from './navbar.component';
import { AvatarModule } from '../avatar';
import { JoinPipe } from '@lockton-apps/shared/util/ng-lodash';
import { MaterialModule } from '@lockton-apps/material';

@NgModule({
  declarations: [NavbarComponent],
  imports: [
    CommonModule,
    ButtonModule,
    MainMenuModule,
    MatIconModule,
    MatMenuModule,
    AvatarModule,
    JoinPipe,
    MaterialModule,
  ],
  exports: [NavbarComponent],
})
export class NavbarModule {}
